export default __webpack_public_path__ + "static/media/logo.e947f941.svg";